import { takeLatest, call, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import I18n from 'i18n'
import editCourse from 'api/administration/courses/Edit'
import { ICourseModel } from 'models/course.model'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { getCourseEditErrorKey } from 'helpers/validators.helper'
import * as fromActions from '../../actions/courses.action'

async function handleEditCourse(course: ICourseModel, courseId: string) {
  return editCourse(course, courseId)
}

function* editCourseEffectSaga(action: any) {
  try {
    yield call(handleEditCourse, action.payload.course, action.payload.courseId)
    if (action.payload.onlySave) {
      yield put(push('/administration/courses/'))
    } else {
      yield put(fromActions.Actions.getAdminCourse(action.payload.courseId))
      yield put(
        push(`/administration/courses/${action.payload.courseId}/lessons/`)
      )
    }
  } catch (error) {
    yield put(fromActions.Actions.setCourseLoading(false))
    const errorKey = getCourseEditErrorKey(error)
    ErrorToast(I18n.t(`administration.toastMessages.${errorKey}`))
    console.log('error: ', error)
  }
}

export function* editCourseWatcherSaga() {
  yield takeLatest(fromActions.EDIT_COURSE, editCourseEffectSaga)
}
